module.exports = __webpack_public_path__ + "static/media/m1_sf_1.e8917acb.png";